import { AlignLeft, Bolt, BookOpen, Home, Inspect, Radio } from 'lucide-react';
import { useParams } from 'react-router';

import { Command } from '@components/features/CommandMenu/Command';
import { Restricted } from '@components/features/Restricted';
import { docsHref } from '@utils/docs';

export function GlobalCommands() {
  const { teamUuid } = useParams();

  return (
    <>
      {teamUuid != null && (
        <Restricted
          allow="internal"
          render={
            <Command
              type="route"
              id="admin-team"
              label="Team Admin"
              group="Internal"
              icon={<Inspect />}
              href={`/admin/${teamUuid}`}
              context="global"
            />
          }
        />
      )}
      <Restricted
        allow="internal"
        render={
          <Command
            type="route"
            id="admin"
            label="Admin"
            group="Internal"
            icon={<Bolt />}
            href="/admin"
            context="global"
          />
        }
      />
      <Command
        type="route"
        id="ev-home"
        label="Home"
        group="Evervault"
        icon={<Home />}
        href="https://evervault.com"
        context="global"
      />
      <Command
        type="route"
        id="global-docs"
        label="Docs"
        group="Evervault"
        icon={<BookOpen />}
        href={docsHref()}
        context="global"
      />
      <Command
        type="route"
        id="legal-terms"
        label="Terms"
        group="Evervault"
        icon={<AlignLeft />}
        href="https://evervault.com/legal/terms"
        context="global"
      />
      <Command
        type="route"
        id="legal-privacy"
        label="Privacy"
        group="Evervault"
        icon={<AlignLeft />}
        href="https://evervault.com/legal/privacy"
        context="global"
      />
      <Command
        type="route"
        id="ev-status"
        label="Status"
        group="Evervault"
        icon={<Radio />}
        href="https://status.evervault.com"
        context="global"
      />
    </>
  );
}
